/**
 * PDP info accordions: opening one closes any other open accordion
 * in the same product info column (exclusive accordion pattern).
 */
(function () {
  'use strict';

  function initGroup(container) {
    if (!container || container.dataset.pdpAccordion === '1') return;
    container.dataset.pdpAccordion = '1';

    var detailsList = container.querySelectorAll('.product__accordion details');
    if (!detailsList.length) return;

    detailsList.forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        detailsList.forEach(function (other) {
          if (other !== details && other.open) other.open = false;
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.product__info-container').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
